<template>
  <div class="table-container">
    <!-- 搜索栏（固定） -->
    <div class="search-container" :class="{ 'mobile-search-top': !isDesktop }">
      <!-- 电脑端使用 Element UI 搜索框 -->
      <div v-if="isDesktop" class="desktop-search-wrapper">
        <div class="search-row">
          <el-input 
            v-model="searchKeyword" 
            placeholder="请输入用户姓名/手机号/订单号" 
            clearable
            size="small"
            class="search-input"
          >
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
          <div class="button-group">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-filter" 
              @click="toggleFilter"
              class="filter-button"
            >
              {{ isFilterOpen ? '收起筛选' : '展开筛选' }}
            </el-button>
          </div>
        </div>
        
        <!-- 电脑端筛选面板 -->
        <div v-if="isFilterOpen" class="filter-panel">
          <div class="filter-row">
            <div class="filter-item">
              <label>寺庙：</label>
              <el-select v-model="filterForm.temple_id" placeholder="请选择需搜索寺庙" filterable clearable size="small" style="width: 150px;">
                <el-option
                  v-for="item in templeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>订单类型：</label>
              <el-select v-model="filterForm.type" placeholder="请选择订单类型" filterable clearable size="small" style="width: 150px;">
                <el-option
                  v-for="item in orderType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>供奉类型：</label>
              <el-select v-model="filterForm.bless_id" placeholder="请选择需搜索供奉类型" multiple filterable clearable size="small" style="width: 150px;">
                <el-option
                  v-for="item in blessList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="filter-item">
              <label>开始日期：</label>
              <el-date-picker
                v-model="filterForm.start_time"
                type="date"
                format="yyyy-MM-dd 日"
                value-format="yyyy-MM-dd"
                placeholder="请选择开始日期"
                size="small"
                style="width: 150px;"
              ></el-date-picker>
            </div>
            <div class="filter-item">
              <label>结束日期：</label>
              <el-date-picker
                v-model="filterForm.end_time"
                type="date"
                format="yyyy-MM-dd 日"
                value-format="yyyy-MM-dd"
                placeholder="请选择结束日期"
                size="small"
                style="width: 150px;"
              ></el-date-picker>
            </div>
          </div>
          <div class="filter-actions">
            <div class="applied-filters">
              <span v-if="appliedFilterForm.temple_id" class="filter-tag">
                寺庙: {{ getTempleName(appliedFilterForm.temple_id) }}
              </span>
              <span v-if="appliedFilterForm.type" class="filter-tag">
                订单类型: {{ getOrderTypeName(appliedFilterForm.type) }}
              </span>
              <span v-if="appliedFilterForm.bless_id && appliedFilterForm.bless_id.length > 0" class="filter-tag">
                供奉类型: {{ appliedFilterForm.bless_id.length }}个
              </span>
              <span v-if="appliedFilterForm.start_time" class="filter-tag">
                开始日期: {{ appliedFilterForm.start_time }}
              </span>
              <span v-if="appliedFilterForm.end_time" class="filter-tag">
                结束日期: {{ appliedFilterForm.end_time }}
              </span>
              <span v-if="!appliedFilterForm.temple_id && !appliedFilterForm.type && !appliedFilterForm.bless_id.length && !appliedFilterForm.start_time && !appliedFilterForm.end_time" class="filter-tag filter-tag-empty">
                当前无筛选条件
              </span>
            </div>
            <div class="filter-buttons">
              <el-button size="small" @click="resetFilter">重置筛选</el-button>
              <el-button type="primary" size="small" @click="applyFilter">应用筛选</el-button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 手机端使用 Vant 搜索框 -->
      <div v-else class="mobile-search-wrapper">
        <van-search
          v-model="searchKeyword"
          placeholder="请输入用户姓名/手机号/订单号"
          show-action
          @search="handleSearch"
          @cancel="onSearchCancel"
          :placeholder-style="{ fontSize: '16px' }"
          :input-align="'center'"
        >
          <template #action>
            <div @click="handleSearch" style="margin-right: 10px; font-size: 16px; color: var(--primary); font-weight: 600;">搜索</div>
          </template>
        </van-search>
        
        <!-- 手机端筛选面板 -->
        <div v-if="isFilterOpen" class="mobile-filter-panel">
          <!-- 手机端已应用筛选条件显示 -->
          <div class="mobile-applied-filters">
            <div v-if="appliedFilterForm.temple_id || appliedFilterForm.type || appliedFilterForm.bless_id.length || appliedFilterForm.start_time || appliedFilterForm.end_time" class="applied-title">已应用筛选条件：</div>
            <div class="applied-tags">
              <span v-if="appliedFilterForm.temple_id" class="mobile-filter-tag">
                寺庙: {{ getTempleName(appliedFilterForm.temple_id) }}
              </span>
              <span v-if="appliedFilterForm.type" class="mobile-filter-tag">
                订单类型: {{ getOrderTypeName(appliedFilterForm.type) }}
              </span>
              <span v-if="appliedFilterForm.bless_id && appliedFilterForm.bless_id.length > 0" class="mobile-filter-tag">
                供奉类型: {{ appliedFilterForm.bless_id.length }}个
              </span>
              <span v-if="appliedFilterForm.start_time" class="mobile-filter-tag">
                开始日期: {{ appliedFilterForm.start_time }}
              </span>
              <span v-if="appliedFilterForm.end_time" class="mobile-filter-tag">
                结束日期: {{ appliedFilterForm.end_time }}
              </span>
              <span v-if="!appliedFilterForm.temple_id && !appliedFilterForm.type && !appliedFilterForm.bless_id.length && !appliedFilterForm.start_time && !appliedFilterForm.end_time" class="mobile-filter-tag empty">
                当前无筛选条件
              </span>
            </div>
          </div>
          
          <van-cell title="寺庙" is-link @click="showTemplePicker = true">{{ getTempleName(filterForm.temple_id) || '全部' }}</van-cell>
          <van-cell title="订单类型" is-link @click="showTypePicker = true">{{ getOrderTypeName(filterForm.type) || '全部' }}</van-cell>
          <van-cell title="供奉类型" is-link @click="showBlessPicker = true">{{ filterForm.bless_id.length > 0 ? filterForm.bless_id.length + '个' : '全部' }}</van-cell>
          <van-cell title="开始日期" is-link @click="showStartDatePicker = true">{{ filterForm.start_time || '全部' }}</van-cell>
          <van-cell title="结束日期" is-link @click="showEndDatePicker = true">{{ filterForm.end_time || '全部' }}</van-cell>
          <div class="mobile-filter-actions">
            <van-button type="default" size="small" @click="resetFilter">重置</van-button>
            <van-button type="primary" size="small" @click="applyFilter">应用</van-button>
          </div>
        </div>
        
        <!-- 手机端筛选展开按钮 -->
        <div class="mobile-filter-toggle" @click="toggleFilter">
          <van-icon :name="isFilterOpen ? 'arrow-up' : 'arrow-down'" /> 
          <span>{{ isFilterOpen ? '收起筛选' : '展开筛选' }}</span>
        </div>
      </div>
    </div>
    
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      <!-- 电脑端表格 -->
      <div class="table-wrapper" v-if="isDesktop">
        <el-table 
          :data="table" 
          style="width: 100%" 
          tooltip-effect="dark" 
          empty-text="暂无数据"
          class="desktop-table"
          :height="tableHeight"
        >
          <el-table-column
            label="订单类型"
            prop="type_name"
            align="left"
            width="120"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-tag color="#507AFC" style="color:white;" v-if="scope.row.type === 0">{{scope.row.type_name}}</el-tag>
              <el-tag color="#FF720E" style="color:white;" v-if="scope.row.type === 1">{{scope.row.type_name}}</el-tag>
              <el-tag color="#F92C1E" style="color:white;" v-if="scope.row.type === 2">{{scope.row.type_name}}</el-tag>
              <el-tag color="#F92C1E" style="color:white;" v-if="scope.row.type === 3">{{scope.row.type_name}}</el-tag>
              <el-tag color="#62D42C" style="color:white;" v-if="scope.row.type === 4">{{scope.row.type_name}}</el-tag>
              <el-tag color="#507AFC" style="color:white;" v-if="scope.row.type === 5">{{scope.row.type_name}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="场所" prop="temple_name"  align="left" width="120">
            <template slot-scope="scope">
              <span>{{scope.row.temple.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="场景" prop="hall_name"  align="left" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.hall.name">{{scope.row.hall.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="订单明细"
            prop="amount"
            align="left"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 0 || scope.row.type===5">{{scope.row.niche.name}} - {{scope.row.niche.time}}</span>
              <el-popover
                placement="top-start"
                width="220"
                trigger="hover" v-if="scope.row.type === 1">
                <div class="bless-box">

                </div>
                <span slot="reference">{{scope.row.blesses_text}}</span>
              </el-popover>
              <span v-if="scope.row.type === 2">满堂红</span>
              <span v-if="scope.row.type === 3">{{scope.row.product.name}}-{{scope.row.product.time}}</span>
              <span v-if="scope.row.type === 4">{{scope.row.type_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="付款金额"
            prop="amount"
            align="left"
            width="140"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="updated_at"
            align="left"
            width="180"
          ></el-table-column>
          <el-table-column
            label="订单号"
            prop="serial"
            align="left"
            width="180"
          ></el-table-column>
          
          <el-table-column label="用户" prop="user_id" align="left" width="180">
            <template slot-scope="scope">
              <div class="user-info">
                <el-image class="user-info-image" fit="cover" :src="scope.row.avatar"></el-image>
                <span>{{scope.row.real_name}}</span>
              </div>
            </template>
          </el-table-column>
        
          <el-table-column label="操作" align="center" width="155" fixed="right">
            <template slot-scope="scope">
              <div class="table-actions">
                <el-dropdown @command="command($event,scope.row)">
                    <span class="el-dropdown-link" style="color: #409eff">
                      更多操作
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="cancelOrder" divided>取消订单</el-dropdown-item>
                    <el-dropdown-item command="remove" divided>删除订单</el-dropdown-item>
                    <el-dropdown-item command="pay" divided>订单扣款</el-dropdown-item>
                    <el-dropdown-item command="getAli" v-if="scope.row.channel === 1">支付宝订单查询</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 手机端卡片 -->
      <div v-else class="mobile-cards">
        <div 
          v-for="item in table" 
          :key="item.id" 
          class="mobile-card"
        >
          <!-- 订单总额放到卡片最上面 -->
          <div class="card-header">
            <!-- 使用与电脑端相同的颜色值 -->
            <el-tag 
              size="small" 
              :color="item.type === 0 ? '#507AFC' : 
                      item.type === 1 ? '#FF720E' : 
                      item.type === 2 ? '#F92C1E' : 
                      item.type === 3 ? '#F92C1E' : 
                      item.type === 4 ? '#62D42C' : '#507AFC'"
              style="color:white;"
            >
              {{ item.type_name }}
            </el-tag>
            <div class="card-amount"> <span>{{ item.amount }}</span></div>
          </div>
          <div class="card-content">
            <p><strong>订单号:</strong> {{ item.serial }}</p>
            <p><strong>场所:</strong> {{ item.temple.name }}</p>
            <p><strong>场景:</strong> {{ item.hall.name || '-' }}</p>
            <p><strong>订单明细:</strong> 
              <span v-if="item.type === 0 || item.type===5">{{item.niche.name}} - {{item.niche.time}}</span>
              <span v-if="item.type === 1">{{item.blesses_text}}</span>
              <span v-if="item.type === 2">满堂红</span>
              <span v-if="item.type === 3">{{item.product.name}}-{{item.product.time}}</span>
              <span v-if="item.type === 4">{{item.type_name}}</span>
            </p>
            <p><strong>创建时间:</strong> {{ item.updated_at }}</p>
            <p class="user-info-p">
              <strong>用户:</strong> 
              <span class="user-info">
                <el-image class="user-info-image" fit="cover" :src="item.avatar"></el-image>
                <span>{{item.real_name}}</span>
              </span>
            </p>
          </div>
          <div class="card-actions">
            <!-- <van-button 
              type="primary" 
              size="small" 
              plain
              icon="edit"
              @click="handlePay(item)"
              style="margin-right: 10px;"
            >
              订单扣款
            </van-button> -->
            <van-button 
              type="default" 
              size="small" 
              plain
              icon="ellipsis"
              @click="showMoreActions(item)"
            >
              更多操作
            </van-button>
          </div>
        </div>
        
        <!-- 手机端空状态 -->
        <div v-if="table.length === 0" class="mobile-empty">
          暂无数据
        </div>
        
        <!-- 手机端操作菜单，只显示一次 -->
        <van-action-sheet
          v-model="showActionSheet"
          get-container="body"
          :actions="actionSheetActions"
          @select="onActionSheetSelect"
          @close="onActionSheetClose"
        />
      </div>
    </div>
    
    <!-- 分页（固定） -->
    <div class="pagination-container">
      <!-- 手机端订单总额在顶部 -->
      <div v-if="!isDesktop" class="mobile-word">订单总额:  <span>{{total_amount}}</span></div>
      
      <div class="pagination-wrapper">
        <!-- 电脑端订单总额在右侧 -->
        <div v-if="isDesktop" class="word">订单总额:  <span>{{total_amount}}</span></div>
        
        <el-pagination
          v-if="isDesktop"
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          @prev-click="prevpage"
          @next-click="nextpage"
          :page-size="10"
          :total="total"
          :hide-on-single-page="false" :small="true"
        ></el-pagination>
        
        <el-pagination
          v-else
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          @prev-click="prevpage"
          @next-click="nextpage"
          :page-size="10"
          :total="total"
          :hide-on-single-page="false" :small="true"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 手机端选择器弹窗 -->
    <van-popup v-model="showTemplePicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="templeColumns"
        @confirm="onTempleConfirm"
        @cancel="showTemplePicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showTypePicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="typeColumns"
        @confirm="onTypeConfirm"
        @cancel="showTypePicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showBlessPicker" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :columns="blessColumns"
        @confirm="onBlessConfirm"
        @cancel="showBlessPicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showStartDatePicker" position="bottom" get-container="body">
      <van-datetime-picker
        type="date"
        v-model="startDateValue"
        @confirm="onStartDateConfirm"
        @cancel="showStartDatePicker = false"
      />
    </van-popup>
    
    <van-popup v-model="showEndDatePicker" position="bottom" get-container="body">
      <van-datetime-picker
        type="date"
        v-model="endDateValue"
        @confirm="onEndDateConfirm"
        @cancel="showEndDatePicker = false"
      />
    </van-popup>
    
    <!-- 订单扣款弹窗 -->
    <el-dialog title="订单扣款" width="500px" :visible.sync="payShow">
      
      <div style="display: flex;justify-content: flex-start;align-items: center;margin-top:20px;">
        <div>请选择订单结束时间：</div>
        <el-date-picker
          style="margin-left:10px"
          v-model="end_time"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择订单结束的日期时间">
        </el-date-picker>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="payShow = false" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="cancelPay()">确认</el-button>
      </div>
    </el-dialog>
    
    <!-- 更改订单状态弹窗 -->
    <el-dialog title="更改订单状态" width="500px" :visible.sync="statusVisible">
      <el-form :model="formStatus" label-position="top">
        <el-form-item label="订单状态" required>
          <el-select
            v-model="formStatus.status"
            clearable
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in orderType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="statusVisible = false" class="cancel-btn">取 消</el-button>
        <el-button type="primary" @click="changeStatus">更改</el-button>
      </div>
    </el-dialog>
    
    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" width="500px" :visible.sync="orderDetailShow">
      <div v-if="orderDetail" class="order-detail">
        <p><strong>订单号:</strong> {{ orderDetail.order.serial }}</p>
        <p><strong>支付宝交易号:</strong> {{ orderDetail.trade_no }}</p>
        <p><strong>订单状态:</strong> {{ orderDetail.trade_status }}</p>
        <p><strong>支付时间:</strong> {{ orderDetail.pay_time }}</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="orderDetailShow = false" class="cancel-btn">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 静态导入 Vant 弹框组件
import { Dialog, Toast } from 'vant'
import { getTable as getOrder, editData,deleteData,cancelData,getPay,syncAli,getAli,unfreezeAli} from "@/api/order.js";
import { getTemples,getBless} from "@/api/public.js";

export default {
  name: "newindex",
  data() {
    const orderType = [
      {
        value: 0,
        label: "恭请",
      },
      {
        value: 1,
        label: "供奉",
      },
      {
        value: 2,
        label: "满堂红",
      },
      {
        value: 3,
        label: "祈福",
      },
      {
        value: 4,
        label: "行善",
      },
      {
        value: 5,
        label: "为亲人恭请",
      },
    ];
    
    return {
      // 搜索相关
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      isDesktop: true,
      // 筛选相关
      isFilterOpen: false,
      filterForm: {
        temple_id: '',
        type: '',
        bless_id: [],
        start_time: '',
        end_time: ''
      },
      // 保存已应用的筛选条件
      appliedFilterForm: {
        temple_id: '',
        type: '',
        bless_id: [],
        start_time: '',
        end_time: ''
      },
      // 手机端选择器
      showTemplePicker: false,
      showTypePicker: false,
      showBlessPicker: false,
      showStartDatePicker: false,
      showEndDatePicker: false,
      templeColumns: ['全部'],
      typeColumns: ['全部', ...orderType.map(item => item.label)],
      blessColumns: ['全部'],
      startDateValue: new Date(),
      endDateValue: new Date(),
      // 手机端操作菜单
      showActionSheet: false,
      currentRow: null,
      actionSheetActions: [
        { name: '取消订单', type: 'default' },
        { name: '删除订单', type: 'danger' },
        { name: '支付宝订单查询', type: 'default' }
      ],
      
      // 订单相关
      params: {
        page:1,
        temple_id:'',
        hall_id:0,
        bless_id:[],
        project_id:[],
        other_bless_id:"",
        product_id:'',
        type:'',
        keyword:'',
        start_time:'',
        end_time:''
      },
      
      table: [],
      total: 0,
      total_amount:0,
      templeList:[],
      blessList:[],
      orderType: orderType,
      
      // 弹窗相关
      reasonShow:false,
      payShow:false,
      orderDetailShow:false,
      orderDetail:'',
      reason:'',
      end_time:'',//订单结束时间
      formStatus:{id:0,status:''},
      cancelId:'',
      payId:''//扣款订单id
    };
  },
  computed: {
    tableHeight() {
      if (!this.isDesktop) return 'auto'
      // 计算表格高度：减去顶部栏、筛选区域、分页栏和底部的高度
      const headerHeight = 60 // 顶部栏高度
      const searchHeight = this.isFilterOpen ? 180 : 60 // 搜索栏高度（包含筛选面板）
      const paginationHeight = 60 // 分页栏高度
      const footerHeight = 40 // 底部高度
      const padding = 20 // 页面内边距
      return window.innerHeight - headerHeight - searchHeight - paginationHeight - footerHeight - padding - 100 // 100是其他元素的额外高度
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
    // 初始化时，将当前筛选条件设为已应用条件
    this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
    this.initData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initData() {
      getTemples().then(res=>{
        if(res.code === 200){
          this.templeList = res.data
          this.templeColumns = ['全部', ...this.templeList.map(item => item.name)]
        }
      })
      getBless().then(res=>{
        if(res.code === 200){
          this.blessList = res.data
          this.blessColumns = ['全部', ...this.blessList.map(item => item.name)]
        }
      })
      this.getTable()
    },
    handleResize() {
      this.checkScreenSize()
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    handleSearch() {
      this.params.page = 1
      this.getTable()
    },
    // 切换筛选面板
    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen
    },
    // 应用筛选
    applyFilter() {
      // 保存当前筛选条件为已应用条件
      this.appliedFilterForm = JSON.parse(JSON.stringify(this.filterForm))
      this.params.page = 1
      this.getTable()
    },
    // 重置筛选
    resetFilter() {
      // 初始化筛选条件
      const initialFilter = {
        temple_id: '',
        type: '',
        bless_id: [],
        start_time: '',
        end_time: ''
      }
      // 同时重置当前筛选表单和已应用筛选条件
      this.filterForm = JSON.parse(JSON.stringify(initialFilter))
      this.appliedFilterForm = JSON.parse(JSON.stringify(initialFilter))
      this.params.page = 1
      this.getTable()
    },
    // 获取寺庙名称
    getTempleName(templeId) {
      if (!templeId) return ''
      const temple = this.templeList.find(item => item.id === templeId)
      return temple ? temple.name : ''
    },
    // 获取订单类型名称
    getOrderTypeName(typeId) {
      if (!typeId) return ''
      const type = this.orderType.find(item => item.value === typeId)
      return type ? type.label : ''
    },
    // 获取标签颜色
    getTagColor(type) {
      const colorMap = {
        0: '#507AFC',
        1: '#FF720E',
        2: '#F92C1E',
        3: '#F92C1E',
        4: '#62D42C',
        5: '#507AFC'
      }
      return colorMap[type] || '#909399'
    },
    // 手机端寺庙选择确认
    onTempleConfirm(value) {
      const temple = this.templeList.find(item => item.name === value)
      this.filterForm.temple_id = value === '全部' ? '' : (temple ? temple.id : '')
      this.showTemplePicker = false
      this.applyFilter()
    },
    // 手机端订单类型选择确认
    onTypeConfirm(value) {
      const type = this.orderType.find(item => item.label === value)
      this.filterForm.type = value === '全部' ? '' : (type ? type.value : '')
      this.showTypePicker = false
      this.applyFilter()
    },
    // 手机端供奉类型选择确认
    onBlessConfirm(value) {
      const bless = this.blessList.find(item => item.name === value)
      if (value === '全部') {
        this.filterForm.bless_id = []
      } else if (bless) {
        this.filterForm.bless_id = [bless.id]
      }
      this.showBlessPicker = false
      this.applyFilter()
    },
    // 手机端开始日期选择确认
    onStartDateConfirm(value) {
      this.filterForm.start_time = value ? value.toISOString().split('T')[0] : ''
      this.showStartDatePicker = false
      this.applyFilter()
    },
    // 手机端结束日期选择确认
    onEndDateConfirm(value) {
      this.filterForm.end_time = value ? value.toISOString().split('T')[0] : ''
      this.showEndDatePicker = false
      this.applyFilter()
    },
    // 显示手机端更多操作菜单
    showMoreActions(row) {
      this.currentRow = row
      // 根据订单类型动态调整操作菜单
      this.actionSheetActions = [
        { name: '取消订单', type: 'default' },
        { name: '删除订单', type: 'danger' }
      ]
      // 如果是支付宝订单，添加支付宝订单查询选项
      if (row.channel === 1) {
        this.actionSheetActions.push({ name: '支付宝订单查询', type: 'default' })
      }
      this.showActionSheet = true
    },
    // 处理手机端操作菜单选择
    onActionSheetSelect(action, index) {
      if (action.name === '取消订单') {
        this.handleCancelOrder(this.currentRow)
      } else if (action.name === '删除订单') {
        this.handleDelete(this.currentRow)
      } else if (action.name === '支付宝订单查询') {
        this.handleGetAli(this.currentRow)
      }
      this.showActionSheet = false
    },
    // 关闭手机端操作菜单
    onActionSheetClose() {
      this.currentRow = null
    },
    // 处理订单扣款
    handlePay(row) {
      this.payId = row.id
      this.payShow = true
    },
    // 处理取消订单
    handleCancelOrder(row) {
      this.cancelId = row.id
      this.reasonShow = true
    },
    // 处理删除订单
    handleDelete(row) {
      this.$confirm('删除后无法恢复，请慎重考虑，确认删除数据吗？')
        .then(_ => {
          deleteData(row.id).then(res=>{
            this.getTable()
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
          })
        })
        .catch(_ => {});
    },
    // 处理支付宝订单查询
    handleGetAli(row) {
      this.orderDetailShow = true
      getAli(row.id,{}).then(res=>{
        if(res.code === 200){
          this.orderDetail = res.data
          this.orderDetail['order'] = row
        }
      })
    },
    // 获取订单列表
    getTable() {
      this.params.keyword = this.searchKeyword
      this.params.temple_id = this.filterForm.temple_id
      this.params.type = this.filterForm.type
      this.params.bless_id = this.filterForm.bless_id
      this.params.start_time = this.filterForm.start_time
      this.params.end_time = this.filterForm.end_time
      
      getOrder(this.params).then((res) => {
        if (res.code === 200) {
          this.table = res.data.data
          this.total = res.data.total;
          this.total_amount = res.data.total_amount
        }
      });
    },
    // 命令处理
    command(e,row) {
      if(e === 'cancelOrder'){
        this.cancelId = row.id
        this.reasonShow = true
      }
      if(e === 'status'){
        this.formStatus.id = row.id
        this.formStatus.status = row.status
        this.statusVisible = true
      }
      if(e === 'pay'){
        this.payId = row.id
        this.payShow = true
      }
      if(e === 'syncAli'){
        syncAli(row.id,{}).then((res) =>{
          if(res.code === 200){
            this.$message({
              message: res.msg,
              type:'success'
            })
            this.getTable()
          }
        })
      }
      if(e === 'getAli'){
        this.orderDetailShow = true
        getAli(row.id,{}).then(res=>{
          if(res.code === 200){
            this.orderDetail = res.data
            this.orderDetail['order'] = row
          }
        })
      }
      if(e === 'remove'){
        this.$confirm('删除后无法恢复，请慎重考虑，确认删除数据吗？')
          .then(_ => {
            deleteData(row.id).then(res=>{
              this.getTable()
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              });
            })
          })
          .catch(_ => {});
        }
    },
    // 更改订单状态
    changeStatus(){
      editData(this.formStatus.id,{'status':this.formStatus.status}).then(res=>{
        if (res.code === 200){
          this.getTable()
          this.$message({
            type: 'success',
            message: '更改成功!'
          });
          this.statusVisible = false
        }
      })
    },
    //取消订单确认
    cancelReason(){
      cancelData(this.cancelId,{'reason':this.reason}).then(res=>{
        if (res.code === 200){
          this.getTable()
          this.$message({
            type: 'success',
            message: '已取消!'
          });
          this.reasonShow = false
        }
      })
    },
    //扣款订单确认
    cancelPay(){
      if(!this.end_time){
        this.$message({
          type: 'error',
          message: '请选择时间'
        });
      }else{
        getPay({'id':this.payId,'end_time':this.end_time}).then(res=>{
          if (res.code === 200){
            this.getTable()
            this.$message({
              type: 'success',
              message: '已发起扣款!'
            });
            this.payShow = false
          }
        })
      }
    },
    handleSizeChange(val) {
      this.params.page_size = val
      this.getTable()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getTable()
    },
    // 处理 Vant 搜索框取消事件
    onSearchCancel() {
      this.searchKeyword = ''
      this.getTable()
    },
    // 分页处理
    prevpage() {
      this.params.page -= 1;
      this.getTable()
    },
    nextpage() {
      this.params.page += 1;
      this.getTable()
    }
  }
}
</script>

<style scoped lang="scss">
/* 使用全局样式中定义的 CSS 变量 */
.table-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 搜索栏（固定） */
.search-container {
  margin-bottom: 0;
  padding: 20px;
  background-color: var(--background);
  border-radius: var(--border-radius);
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* 手机端搜索置顶 */
.mobile-search-top {
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
  padding: 10px 15px;
}

.search-container h2 {
  margin-bottom: 20px;
  color: var(--text);
}

/* 电脑端搜索容器 */
.desktop-search-wrapper {
  width: 100%;
}

.search-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 100%;
  max-width: 400px;
  font-size: var(--font-size-sm);
}

.filter-button {
  white-space: nowrap;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  align-items: center;
}

/* 筛选面板 */
.filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 15px;
  margin-top: 10px;
  box-shadow: var(--shadow);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 15px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 筛选操作区域 */
.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--border);
}

/* 已应用筛选标签容器 */
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

/* 单个筛选标签样式 */
.filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: var(--font-size-sm);
  display: inline-flex;
  align-items: center;
}

/* 空状态筛选标签 */
.filter-tag-empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 筛选按钮容器 */
.filter-buttons {
  display: flex;
  gap: 10px;
}

.filter-item label {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 手机端已应用筛选条件样式 */
.mobile-applied-filters {
  padding: 10px 15px;
  background-color: var(--bg-100);
  border-radius: var(--border-radius);
  margin-bottom: 15px;
}

.mobile-applied-filters .applied-title {
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
  margin-bottom: 8px;
}

.mobile-applied-filters .applied-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mobile-filter-tag {
  background-color: var(--primary);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: var(--font-size-xs);
  display: inline-block;
}

.mobile-filter-tag.empty {
  background-color: var(--bg-200);
  color: var(--text-200);
}

/* 手机端筛选操作按钮区域 */
.mobile-filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px;
  background-color: var(--background);
  border-top: 1px solid var(--border);
}

/* 手机端搜索容器 */
.mobile-search-wrapper {
  width: 100%;
}

/* 手机端筛选面板 */
.mobile-filter-panel {
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  margin-top: 10px;
  overflow: hidden;
}

/* 手机端筛选展开按钮 */
.mobile-filter-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 10px;
  margin-top: 10px;
  background-color: var(--bg-100);
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  color: var(--text-200);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-filter-toggle:hover {
  background-color: var(--border-light);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 20px 0;
  padding-bottom: 0;
}

/* 电脑端表格 */
.table-wrapper {
  height: 100%;
  margin-bottom: 0;
  border-radius: var(--border-radius);
  overflow: hidden;
  box-shadow: var(--shadow);
  font-size: 14px;
}

.table-actions{
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  gap: 10px;
  font-size: 14px;
}

.desktop-table {
  height: 100%;
  margin-bottom: 0;
  font-size: 14px;
}

/* 手机端卡片 */
.mobile-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
}

.mobile-card {
  border: 1px solid var(--border);
  border-radius: var(--border-radius-lg);
  padding: 15px;
  background-color: var(--bg-200);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.mobile-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border-light);
}

.card-header h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-content {
  border-bottom: 1px solid var(--border-light);
}

.card-content p {
  margin: 8px 0;
  font-size: var(--font-size-sm);
  color: var(--text-200);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  line-height: 1.6;
  flex-wrap: wrap;
}

.card-content p strong {
  color: var(--text);
  font-weight: 500;
  min-width: 80px;
  text-align: left;
  flex-shrink: 0;
}

.card-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 12px;
  flex-wrap: wrap;
  align-items: center;
}

/* Vant按钮样式优化 */
.card-actions .van-button {
  font-size: 13px;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

/* Vant下拉菜单样式优化 */
.card-actions .van-dropdown-menu {
  font-size: 13px;
  flex-shrink: 0;
}

/* 手机端空状态 */
.mobile-empty {
  text-align: center;
  padding: 40px 0;
  color: var(--text-200);
  font-size: var(--font-size-sm);
}

/* 适配小屏幕，确保操作按钮不会换行 */
@media (max-width: 375px) {
  .card-actions {
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
  
  .card-actions .van-button {
    width: 100%;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .card-actions .van-dropdown-menu {
    width: 100%;
  }
}

/* 分页（固定） */
.pagination-container {
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
  border-top: 1px solid var(--border);
  box-sizing: border-box;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.word{
  font-size:13px;
  font-weight: normal;
  color: var(--text);
  span{
    font-size:13px;
    font-weight: 500;
    color: var(--text);
  }
}

/* 手机端订单总额样式 */
.mobile-word {
  font-size: 16px;
  font-weight: 500;
  color: var(--text);
  margin-bottom: 15px;
  text-align: right;
  span {
    font-size: 20px;
    font-weight: 600;
    color: var(--primary);
  }
}

.user-info{
  display: flex;
  align-items:center;
  span{
    margin-left: 10px;
  }
  &-image{
    width:30px;
    height: 30px;
    border-radius:30px;
    overflow:hidden;
    flex-shrink:0;
  }
}

/* 手机端卡片中的用户信息确保左右结构 */
.mobile-card .user-info {
  width: auto;
  flex-shrink: 0;
}

.user-info-p{
  display:inline-flex;
  align-items: center;
  justify-content: space-between;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .search-container h2 {
    margin-bottom: 15px;
  }
  
  .search-container .search-input {
    display: none;
  }
  
  .content-container {
    padding: 10px 0;
  }
  
  .search-input {
    max-width: 100%;
  }
  
  .pagination-container {
    text-align: center;
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .pagination-wrapper{
    justify-content: center;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  
  .filter-item {
    width: 100%;
  }
  
  .filter-item .el-select,
  .filter-item .el-input-number {
    width: 100% !important;
  }
}

@media (min-width: 769px) {
  .search-container .mobile-search-container,
  .mobile-filter-toggle {
    display: none;
  }
  
  .desktop-table {
    display: block;
  }
  
  .mobile-cards {
    display: none;
  }
}

@media (max-width: 768px) {
  .search-container{
    width: 100vw;
    margin-left: -15px;
    border-bottom-left-radius: var(--border-radius);
    border-bottom-right-radius: var(--border-radius);
    background-color: var(--bg-200);
  }
  .van-search{
    padding:0;
  }
  .desktop-table {
    display: none;
  }
  
  .mobile-cards {
    display: flex;
  }
  
  .search-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .search-input {
    max-width: 100%;
  }
}
</style>